// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"23":"ad3e1a73e4b38200","629":"9420e47e8ba0b112","657":"13588afa4962ec0e","780":"2fcebfbac87ffded"}[chunkId] + ".js";
};